import "bootstrap/js/dist/modal";
import "bootstrap/js/dist/collapse";

import Header from "design-system/resources/html/components/common/header/header";
import NavbarMobile from "design-system/resources/html/components/common/navbar-mobile/navbar-mobile";

import CardScroll from "design-system/resources/html/components/common/card-list/card-scroll";
import Guides from "design-system/resources/html/components/common/guides/guides";
import ResponsiveTable from "design-system/resources/html/components/common/responsive-table/responsive-table";

import RiskWarningBar from "design-system/resources/html/components/common/risk-warning-bar/risk-warning-bar";

import getIdCarouselForAutoSlide from "./carousel";
import getIdCarouselForSlide from './carouselDesktopMobile';
import getIdCarouselForGlideSlide from './glide';
import setupLanguageSwitcher from './language-switcher';
// import messengerSet from "design-system/resources/html/components/common/messengers/messengers";

window.onload = function () {
  Header();
  // messengerSet();
  setupLanguageSwitcher();
  NavbarMobile();
  getIdCarouselForAutoSlide();
  Guides();
  ResponsiveTable();
  RiskWarningBar();
  CardScroll();
  getIdCarouselForSlide();
  getIdCarouselForGlideSlide();

};
